import React, { FunctionComponent, PropsWithChildren } from "react";

import { NoneOwnProps } from "@multiweb/types/react";
import { classNames } from "../constants";

type SectionPanelContentProps = PropsWithChildren<NoneOwnProps>;

export const SectionPanelContent: FunctionComponent<SectionPanelContentProps> = ({ children }) => {
    return (<section className={classNames("content")}>
        { children }
    </section>);
};
